import { getImage } from "gatsby-plugin-image";
import React from "react";

import Image from "components/image";
import { useBreakpoint } from "hooks/useBreakpoint";
import { Link } from "utils/customLink";

import MobileGallery from "./gallery/mobileGallery";
import HeaderVideoPlayer from "./headerVideoPlayer";

const Hero = ({
  navLinks,
  heroHeadLine,
  heroImg,
  videoId,
  gallery,
  children,
  layout = "std",
  heroClass = "hero-section flex-col bg-green-dark",
  galleryClass = "mobile-gallery-section relative bg-transparent h-80 w-full sm:hidden",
  featuredVideoGallery = [],
  heroHeadLineClass = "w-full mx-auto text-left text-white uppercase font-body",
  headerInnerContainerClass = "flex flex-col w-3/4 sm:max-w-102",
  heroSubtitlePrimaryClass = "!text-white !font-normal text-center ",
  heroImageExtraClass = "",
  heroDescClass = "pt-6 w-11/12 mx-auto text-white text-center",
  subtextTitle = "",
  subtextContainerClass = "z-10 bottom-0 absolute left-0 w-full",
  subtextInnerContainerClass = "w-11/12 sm:w-10/12 m-auto",
  subtextDescClass = "bg-black-lighter  pl-4 pr-4 pb-2 pt-2 font-extrabold text-white text-base uppercase w-fit tracking-widest sm:no-br"
}) => {
  const heroLocalImg = heroImg ? getImage(heroImg?.localFile) : false;
  const mediaItemUrl = heroImg?.mediaItemUrl ?? heroImg?.sourceUrl ?? heroImg;
  const breakpoint = useBreakpoint();

  return (
    <>
      <section
        key={"shared-hero"}
        className={`flex items-center justify-center mx-auto relative ${heroClass}`}
      >
        {subtextTitle && (
          <div className={subtextContainerClass}>
            <div className={subtextInnerContainerClass}>
              <div
                className={subtextDescClass}
                dangerouslySetInnerHTML={{ __html: subtextTitle }}
              />
            </div>
          </div>
        )}

        {/* mobile gallery */}
        {layout === "h-gal" && (
          <>
            {breakpoint && breakpoint === "xs" && gallery?.length > 0 ? (
              <MobileGallery
                containerClass={galleryClass}
                gallery={gallery}
                featuredVideoGallery={featuredVideoGallery}
              />
            ) : (
              <>
                {!videoId &&
                  heroLocalImg &&
                  heroImg &&
                  heroImg?.localFile?.extension &&
                  heroImg?.localFile?.extension !== "svg" && (
                    <Image
                      imageAlt=""
                      image={heroLocalImg}
                      imageClass={`absolute z-0 object-cover w-full h-full ${heroImageExtraClass}`}
                      sourceUrl={mediaItemUrl}
                      extraProps={{ loading: "eager" }}
                    />
                  )}

                {!videoId && !heroLocalImg && (
                  <Image
                    imageAlt=""
                    image={heroImg}
                    imageClass={`absolute z-0 object-cover w-full h-full ${heroImageExtraClass}`}
                    sourceUrl={mediaItemUrl}
                    extraProps={{ loading: "eager" }}
                  />
                )}
              </>
            )}
          </>
        )}

        {layout !== "h-gal" && (
          <>
            {((breakpoint && breakpoint === "xs") || !videoId) &&
              heroLocalImg &&
              heroImg &&
              heroImg?.localFile?.extension &&
              heroImg?.localFile?.extension !== "svg" && (
                <Image
                  imageAlt=""
                  image={heroLocalImg}
                  imageClass={`absolute z-0 object-cover w-full h-full ${heroImageExtraClass}`}
                  sourceUrl={mediaItemUrl}
                  extraProps={{ loading: "eager" }}
                />
              )}

            {((breakpoint && breakpoint === "xs") || !videoId) &&
              !heroLocalImg && (
                <Image
                  imageAlt=""
                  image={heroImg}
                  imageClass={`absolute z-0 object-cover w-full h-full ${heroImageExtraClass}`}
                  sourceUrl={mediaItemUrl}
                  extraProps={{ loading: "eager" }}
                />
              )}
          </>
        )}

        {breakpoint && breakpoint !== "xs" && videoId && (
          <div
            className={
              "z-1 w-full bg-transparent absolute object-contain h-full overflow-hidden"
            }
          >
            <HeaderVideoPlayer jwplayerID={videoId} heroImg={heroImg} />
          </div>
        )}

        {children ? (
          children
        ) : (
          <div className="container absolute z-10 w-11/12 md:w-10/12">
            <div className={headerInnerContainerClass}>
              <h4
                className={`${heroHeadLineClass} font-light heading1 text-shadow-sm`}
                dangerouslySetInnerHTML={{
                  __html:
                    heroHeadLine?.title ??
                    heroHeadLine
                      .split(" ")
                      .slice(0, 2)
                      .map((word) => `<span class='font-bold'>${word}</span>`)
                      .concat(heroHeadLine.split(" ").slice(2))
                      .join(" ")
                }}
              />
              {heroHeadLine?.subTitle && (
                <div className="pt-6 w-1/2  mx-auto">
                  <h2
                    className={heroSubtitlePrimaryClass}
                    dangerouslySetInnerHTML={{
                      __html: heroHeadLine?.subTitle
                    }}
                  />
                </div>
              )}
              {heroHeadLine?.desc && (
                <div
                  className={heroDescClass}
                  dangerouslySetInnerHTML={{ __html: heroHeadLine?.desc }}
                />
              )}
            </div>
            {navLinks && navLinks.length > 0 && (
              <div className="flex flex-row flex-wrap items-center justify-center w-10/12 md:w-full pt-4">
                {navLinks &&
                  navLinks.length > 0 &&
                  navLinks.map((nav, index) => (
                    <React.Fragment key={index}>
                      {nav?.text && nav?.toPage && (
                        <div
                          key={index}
                          className="flex flex-row justify-start px-1 md:justify-center"
                        >
                          {nav.imgPath && (
                            <Image
                              imageAlt="Location"
                              image={""}
                              imageClass="object-contain object-center location-icon pr-4 "
                              sourceUrl={`/${nav.imgPath}`}
                              extraProps={{ loading: "eager" }}
                            />
                          )}
                          <Link
                            className="text-white program-location link-white-underline underline-offset-4"
                            to={nav.toPage}
                          >
                            {index === navLinks.length - 1
                              ? `${nav.text}`
                              : `${nav.text}, `}
                          </Link>
                        </div>
                      )}
                    </React.Fragment>
                  ))}
              </div>
            )}
          </div>
        )}
      </section>
    </>
  );
};

export default Hero;
